import React from 'react';
import styled from 'astroturf/react';

import StarIcon from 'js/svg/colorless/star.svg';

const Container = styled.div<{ selected?: boolean; hovered?: boolean }>`
  --star-color: #b4c7e8;
  --size: 24px;
  --expanded-size: 27px;
  --filter: drop-shadow(0 0 4px transparent);

  &.selected,
  &.hovered {
    --star-color: var(--button-secondary-stroke-hover, #386ac1);
  }

  &.hovered {
    --size: var(--expanded-size);
    --filter: drop-shadow(0 0 2px var(--star-color));
  }

  svg {
    fill: var(--star-color);
    width: var(--size);
    height: var(--size);
    filter: var(--filter);
    transition: all 100ms ease-out;
  }
`;

type Props = {
  className?: string;
  selected?: boolean;
  hovered?: boolean;
};

const Star: React.FC<Props> = ({ className, selected, hovered }) => {
  return (
    <Container className={className} selected={selected} hovered={hovered}>
      <StarIcon />
    </Container>
  );
};

export default Star;
